export const SOURCING_EXTERNAL_YEARS_OF_EXPERIENCE = [
  {
    label: '0-1',
    value: '0_1'
  },
  {
    label: '1-2',
    value: '1_2'
  },
  {
    label: '3-5',
    value: '3_5'
  },
  {
    label: '6-10',
    value: '6_10'
  },
  {
    label: '10+',
    value: '10'
  }
] as const;
